import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // You can modify the request config here
    // For example, add auth tokens
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
